import { ListTradesReq } from '#/unified-rfqs/repositories/grfq-types';
import { Trade } from '#/unified-rfqs/entities/shared';
import TradesStore from '#/unified-rfqs/store/trades';
import { GrfqService } from '#/unified-rfqs/services/grfq';
import { DrfqService } from '#/unified-rfqs/services/drfq';
import { MergedSourcesFetcher } from '#/unified-rfqs/services/merged-sources-fetcher';
import PublicStore from '#/unified-rfqs/store/public-store';

interface TradesServiceDeps {
  tradesStore: TradesStore;
  grfqService: GrfqService;
  drfqService: DrfqService;
}

const PAGE_SIZE = 50;

export default class UnifiedTradesService extends PublicStore<Trade> {
  readonly fetcher: MergedSourcesFetcher<ListTradesReq, Trade>;
  constructor(deps: TradesServiceDeps) {
    const { grfqService, drfqService, tradesStore } = deps;
    super(tradesStore);

    this.fetcher = new MergedSourcesFetcher<ListTradesReq, Trade>({
      pageSize: PAGE_SIZE,
      fetchers: [grfqService.listTrades, drfqService.listTrades],
      store: tradesStore,
    });
  }
}
